import type { StringSchema } from "yup";
import { z } from "zod";

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 72;

export const PASSWORD_ALLOWED_CHARACTERS_REGEX =
	/^[A-Za-z0-9 !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/;
export const PASSWORD_ALPHABET_REGEX = /[A-Za-z]/;
export const PASSWORD_DIGIT_REGEX = /[0-9]/;

export const PASSWORD_MIN_LENGTH_MESSAGE = `${PASSWORD_MIN_LENGTH}文字以上で設定してください`;
export const PASSWORD_MAX_LENGTH_MESSAGE = `${PASSWORD_MAX_LENGTH}文字以内で設定してください`;
export const PASSWORD_ALLOWED_CHARACTERS_MESSAGE =
	"半角英数字と記号で入力してください";
export const PASSWORD_COMBINATION_MESSAGE = "英字と数字を組み合わせてください";
export const PASSWORD_RULE_HELP_TEXT =
	"半角英字と数字を含む8文字以上で設定してください";

export const createPasswordZodSchema = (requiredMessage: string) =>
	z
		.string()
		.refine((value) => value.length > 0, requiredMessage)
		.min(PASSWORD_MIN_LENGTH, PASSWORD_MIN_LENGTH_MESSAGE)
		.max(PASSWORD_MAX_LENGTH, PASSWORD_MAX_LENGTH_MESSAGE)
		.regex(
			PASSWORD_ALLOWED_CHARACTERS_REGEX,
			PASSWORD_ALLOWED_CHARACTERS_MESSAGE
		)
		.regex(PASSWORD_ALPHABET_REGEX, PASSWORD_COMBINATION_MESSAGE)
		.regex(PASSWORD_DIGIT_REGEX, PASSWORD_COMBINATION_MESSAGE);

// VendorCompanyのフォームがyupのまま残っているためのyup版。
// zodResolverに統一できればcreatePasswordZodSchemaのみで足りる。
export const applyPasswordRules = (schema: StringSchema): StringSchema =>
	schema
		.min(PASSWORD_MIN_LENGTH, PASSWORD_MIN_LENGTH_MESSAGE)
		.max(PASSWORD_MAX_LENGTH, PASSWORD_MAX_LENGTH_MESSAGE)
		.matches(PASSWORD_ALLOWED_CHARACTERS_REGEX, {
			excludeEmptyString: true,
			message: PASSWORD_ALLOWED_CHARACTERS_MESSAGE
		})
		.matches(PASSWORD_ALPHABET_REGEX, {
			excludeEmptyString: true,
			message: PASSWORD_COMBINATION_MESSAGE
		})
		.matches(PASSWORD_DIGIT_REGEX, {
			excludeEmptyString: true,
			message: PASSWORD_COMBINATION_MESSAGE
		});
